import { formatCompact, formatPrice, formatUsd, shorten } from "../lib/format";
import type { Market } from "../lib/types";
import { TokenAvatar } from "./TokenAvatar";

export function MarketOverview({ market, solUsdPrice }: { market: Market; solUsdPrice?: number }) {
  return (
    <section className="market-summary panel">
      <div className="token-hero">
        <TokenAvatar name={market.name} symbol={market.symbol} image={market.image} size="large" />
        <div className="token-title">
          <h1>{market.name} <span>${market.symbol}</span></h1>
          <a className="mint-link" href={`https://solscan.io/token/${market.mint}`} target="_blank" rel="noreferrer">{shorten(market.mint)} ↗</a>
        </div>
        <span className="hero-status public">
          <i /> Live
        </span>
      </div>

      <div className="summary-stats">
        <div><span>Price</span><strong>{formatPrice(market.priceSol)} SOL</strong></div>
        <div>
          <span>Market cap</span>
          <strong>{formatUsd(solUsdPrice === undefined ? undefined : market.marketCapSol * solUsdPrice)}</strong>
          <small>{formatCompact(market.marketCapSol)} SOL</small>
        </div>
      </div>

      <div className="market-links">
        {market.github && <a className="github-link" href={market.github} target="_blank" rel="noreferrer">Open GitHub ↗</a>}
        <a className="pool-link" href={`https://solscan.io/account/${market.pool}`} target="_blank" rel="noreferrer">View pool on Solscan ↗</a>
      </div>
    </section>
  );
}
